export const EMXialaExternalId = {
  driver: '2a3817545ad34c91b465f4a480e737de',
  user: '87b8fac2f6154ee397fc6c8c21d2b644'
};

// 小拉登录coupe请求
export const getXlCoupe = coupeId => {
  const host = location.hostname;
  let url = '';
  // process.env.NODE_ENV
  const ENV =
    host.indexOf('-stg') !== -1
      ? 'stg'
      : host.indexOf('-pre') !== -1
      ? 'pre'
      : '';
  return new Promise((resolve, reject) => {
    try {
      if (!coupeId) {
        resolve({});
        console.log('coupe id为空,默认登录');
        return;
      }
      if (ENV == 'dev' || ENV == 'stg') {
        url = `https://coupe-api.xlcx.work/schema/stg/${coupeId}_data.json`;
      } else if (ENV == 'pre') {
        url = `https://coupe-api.xlcx.work/schema/pre/${coupeId}_data.json`;
      } else {
        url = `https://coupe-static.xiaolachuxing.com/schema/${coupeId}_data.json`;
      }
      fetch(url, { method: 'GET' })
        .then(res => res.json())
        .then(res => {
          // res即是coupe中的配置信息。
          console.log('coupe中的配置信息' + JSON.stringify(res.data));
          resolve(res.data);
        })
        .catch(res => reject(res));
    } catch (e) {
      resolve({});
      console.log('coupe数据获取失败' + JSON.stringify(e));
    }
  });
};
